module.exports = __webpack_public_path__ + "img/CN_微信.f227752f.jpg";